/**
 * Created by VRUNDA on 23-12-2020.
 */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Configuration } from '../config/config';
import 'rxjs/add/operator/map';

@Injectable()
export class JourneyService {
  public jwtToken: string;
  constructor(private http: HttpClient) {
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  refreshToken(){
    const theUser:any = JSON.parse(localStorage.getItem('currentUser'));
    if (theUser) {
      this.jwtToken = theUser.token;
    }
  }

  checkPassword(obj){
    return this.http.post(Configuration.ServerWithApiUrl+ '/confirmPassword', obj)
      .map((res: any)=>res)
  }

  saveNewSkill(skill){
    return this.http.post(Configuration.ServerWithApiUrl+'/skills',skill)
      .map((res: any)=>res)
  }

  getAllSkills() {
    return this.http.get(Configuration.ServerWithApiUrl + '/skills')
      .map((res: any) => res)
  }

  getAllVideos() {
    return this.http.get(Configuration.ServerWithApiUrl + '/video')
      .map((res: any) => res)
  }

  getUserPreferenceData(obj: any) {
    // return this.http.get(Configuration.ServerWithApiUrl + '/userPreference/'+obj)
    //   .map((res: any)=>res)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Referrer-Policy': 'no-referrer',
    });
    const requestOptions = { headers: headers };
    return this.http.get(Configuration.CoachingServerURL + 'userPreference/' + obj, requestOptions)
      .map((res: any) => res)
  }
  getCoachingGameDetails(user_id, game_id, comm_id, journey_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/transactionMetaData1/users/' + user_id + '?community_id=' + comm_id + '&journey_id=' + journey_id)
      .map((res: any) => res)
  }

  projectGrading(obj) {
    return this.http.post(Configuration.Server + 'project/grading', obj)
      .map((res: any) => res)
  }

  getAllGames() {
    return this.http.get(Configuration.ServerWithApiUrl + '/game')
      .map((res: any) => res)
  }

  getAllCertificates() {
    return this.http.get(Configuration.ServerWithApiUrl + '/certificate')
      .map((res: any) => res)
  }

  getAllResources() {
    return this.http.get(Configuration.ServerWithApiUrl + '/resourceAll')
      .map((res: any) => res)
  }

  getAllUrlContent() {
    return this.http.get(Configuration.ServerWithApiUrl + '/urlContent')
      .map((res: any) => res)
  }
  getAllEventContent() {
    return this.http.get(Configuration.ServerWithApiUrl + '/eventContent')
      .map((res: any) => res)
  }

  saveJourney(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/journey', data)
      .map((res: any) => res)
  }

  getAllJourney() {
    return this.http.get(Configuration.ServerWithApiUrl + '/journey')
      .map((res: any) => res)
  }

  deleteJourneyById(id) {
    return this.http.delete(Configuration.ServerWithApiUrl + '/journey/' + id)
      .map((res: any) => res)
  }

  editJourney(data, flag) {
    return this.http.post(Configuration.ServerWithApiUrl + '/journey_edit/' + flag, data)
      .map((res: any) => res)
  }

  getJourneyById(id, version) {
    return this.http.get(Configuration.ServerWithApiUrl + '/journey/' + id + '/' + version)
      .map((res: any) => res)
  }

  getJourneyDetailsByLang(id, version, lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/journey/' + id + '/' + version + '/' + lang)
      .map((res: any) => res)
  }
  getLatestJourneyDetailsById(id, lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getLatestJourneyDetailsById/' + id + '/' + lang)
      .map((res: any) => res)
  }

  getJourneyTransDetails(journeyId, user_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getJourneyTransDetails/' + journeyId + '/' + user_id)
      .map((res: any) => res)
  }

  getVideoById(id, lang_id, lang_name) {
    return this.http.get(Configuration.ServerWithApiUrl + '/video/' + id + '/' + lang_id + '/' + lang_name)
      .map((res: any) => res)
  }

  updatePlayedJourneySteps(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/journey_transaction', data)
      .map((res: any) => res)
  }
  updateGameLearnTime(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/journey_transaction_learnTime', data)
      .map((res: any) => res)
  }

  getResourceDetailsById(id, lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/resource/' + id + '/' + lang)
      .map((res: any) => res)
  }

  validateResourceUrl(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/validateResourceUrl', data)
      .map((res: any) => res)
  }

  getGameJsonData(gameName, flag, language, data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/readFile/' + gameName + '/' + flag + '/' + language, data)
      .map((res: any) => res)
  }
  validateJourneyToPublish(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/validateJourneyToPublish', data)
      .map((res: any) => res)
  }

  publishJourneyContent(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/publishJourneyContent', data)
      .map((res: any) => res)
  }

  getResourceConfiguration(id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getResourceConfig/' + id)
      .map((res: any) => res)
  }

  getCertificateById(id, version, lang_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getCertificateByIdWithDeleted/' + id + '/' + version + '/' + lang_id)
      .map((res: any) => res)
  }

  getLatestCertificateById(id, lang_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getLatestCertificateById/' + id + '/' + lang_id)
      .map((res: any) => res)
  }

  getAssessmentById(id, lang_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/assessment_details/' + id + '/' + lang_id)
      .map((res: any) => res)
  }

  urlContent(id, lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/urlContent/' + id + '/' + lang)
      .map((res: any) => res)
  }
  batchLinkContent(lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/batchLinkContent/' + lang)
      .map((res: any) => res)
  }
  eventContent(id, lang) {
    return this.http.get(Configuration.ServerWithApiUrl + '/eventContent/' + id + '/' + lang)
      .map((res: any) => res)
  }

  getAllCommunities() {
    return this.http.get(Configuration.ServerWithApiUrl + '/communitiesnames')
      .map((res: any) => res)
  }

  getAllPublishedJourneys() {
    return this.http.get(Configuration.ServerWithApiUrl + '/publishedJourney')
      .map((res: any) => res)
  }

  updatePlayedCertificateSteps(transaction_obj) {
    return this.http.put(Configuration.ServerWithApiUrl + '/updatePlayedCertificateSteps', transaction_obj)
      .map((res: any) => res)
  }

  getPlayedCertificateSteps(transaction_obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/getPlayedCertificateSteps', transaction_obj)
      .map((res: any) => res)
  }

  saveAssessmentForUser(obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/assessment_evaluation', obj)
      .map((res: any) => res)
  }

  updateLearnerTransaction(transaction_obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/learner_transaction', transaction_obj)
      .map((res: any) => res)
  }

  getRespectiveInstructionOfCert(playedStepsData, stepData) {

    for (let s = 0; s < stepData.length; s++) {
      var picked;
      const step = stepData[s];

      if (playedStepsData.played_steps && playedStepsData.played_steps.length > 0) {

        if (step != undefined) {
          picked = playedStepsData.played_steps.find(steps => steps.step_uid === step.step_id);
        }

        if (picked == undefined) {
          let unMatcheSteps = [];
          let notMandatorySteps = [];
          let completedSteps = [];
          var curretnt = 0;
          for (let i = 0; i < stepData.length; i++) {
            let flag = false;
            for (let j = 0; j < playedStepsData.played_steps.length; j++) {
              if (stepData[i].step_id == playedStepsData.played_steps[j].step_uid) {
                flag = true;
                curretnt = j;
                break;
              }
            }
            if (!flag) {
              if (stepData[i].is_mandatory) {
                unMatcheSteps.push(stepData[i]);
              } else {
                notMandatorySteps.push(stepData[i]);
              }
            } else {
              if (stepData[i].is_mandatory) {
                completedSteps.push(playedStepsData.played_steps[curretnt]);
              }
            }
          }
          var flag = false;
          for (let i = 0; i < completedSteps.length; i++) {
            if (completedSteps[i].status == 'Inprogress') {
              flag = true;
            }
          }
          if (unMatcheSteps.length > 0) {
            if (unMatcheSteps[0].step_id == step.step_id && flag == false) {
              if (stepData[stepData.length - 1].step_id == unMatcheSteps[0].step_id) {
                return { choice: 'start', step_name: step.name };
              } else {
                return { choice: 'start', step_name: step.name };
              }
            } else {
              let flag = false;
              let val = 0;
              for (let i = 0; i < notMandatorySteps.length; i++) {
                if (notMandatorySteps[i].step_id == step.step_id) {
                  flag = true;
                  val = i;
                }
              }
            }
          }
        } else {
          if (picked.status == 'Inprogress') {
            if (step.is_mandatory) {
              return { choice: 'Inprogress', step_name: step.name };
            }
          }
        }
      } else {
        let flag = false;
        let val = 0;
        var mandatory = [];
        var notmandatory = [];

        for (let i = 0; i < stepData.length; i++) {
          if (stepData[i].is_mandatory == true) {
            mandatory.push(stepData[i]);
          } else {
            notmandatory.push(stepData[i]);
          }
        }
        for (let i = 0; i < notmandatory.length; i++) {
          if (notmandatory[i].step_id == step.step_id) {
            flag = true;
            val = i;
          }
        }
        if (flag) {

        } else {
          if (mandatory[0].step_id == step.step_id) {
            return { choice: 'start', step_name: step.name };
          } else {
          }
        }
      }
    }
  }

  getUserConfig(user_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getUserConfig/' + user_id)
      .map((res: any) => res)
  }

  getUserSubscribedCertificates(user_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/subscribed_certificate/' + user_id)
      .map((res: any) => res)
  }

  isCertAssignedToComm(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/isCertAssignedToComm', data)
      .map((res: any) => res)
  }

  getLicenseByCertificateId(certificate_id, community_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getLicenseByCertificateId/' + certificate_id + '/' + community_id)
      .map((res: any) => res)
  }

  getCouponsByCode(code, communityId) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getCouponByCode/' + code + '/' + communityId)
      .map((res: any) => res)
  }

  saveLicenseForUser(Obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/saveLicenseForUser', Obj)
      .map((res: any) => res)
  }

  updateUsedCoupos(data) {
    return this.http.put(Configuration.ServerWithApiUrl + '/coupons', data)
      .map((res: any) => res)
  }

  getCommListByJourneyId(id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getCommByJourneyId/' + id)
      .map((res: any) => res)
  }
  getJourneyProgressByUser(id, comm_id, user_id) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getJourneyProgressByUserId/' + id + '/' + comm_id + '/' + user_id)
      .map((res: any) => res)
  }
  getKeyLearnJSONData(lang, gameName) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getKeyLearnJSONData/' + gameName + '/' + lang)
      .map((res: any) => res)
  }

  updateActivatedGameInJourney(Obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/updateActivatedGameInJourney', Obj)
      .map((res: any) => res)
  }
  updateActivatedEventInJourney(Obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/updateActivatedEventInJourney', Obj)
      .map((res: any) => res)
  }

  saveKeyLearnDateInJourneyGame(Obj) {
    return this.http.post(Configuration.ServerWithApiUrl + '/saveKeyLearnDateInJourneyGame', Obj)
      .map((res: any) => res)
  }

  getAllAssessment() {
    return this.http.get(Configuration.ServerWithApiUrl + '/assessment')
      .map((res: any) => res)
  }

  getAllStepStatus(playedStepsData, stepData, activatedSteps) {

    let visibleStep = [];
    let disabledStep = [];
    let activeStep = '';
    let activateGameStep = [];
    let keyLearnStep = '';
    let isPrevStepCompleted = false;

    for (let a = 0; a < stepData.length; a++) {

      for (let b = 0; b < stepData[a].stepsList.length; b++) {
        a == 0 && b == 0 ? isPrevStepCompleted = true : '';

        if (stepData[a].stepsList[b].is_visible) {

          if (stepData[a].stepsList[b].is_mandatory) {

            if (playedStepsData && playedStepsData.length > 0) {

              let ind = playedStepsData.findIndex(ob => ob.step_id == stepData[a].stepsList[b].step_id);
              if (ind > -1) {
                if (playedStepsData[ind].status == 'Completed') {
                  if (stepData[a].stepsList[b].type == 'Game' && stepData[a].stepsList[b].is_key_learn_mandatory) {
                    if (playedStepsData[ind].key_learn_attempted_date && playedStepsData[ind].key_learn_attempted_date > 0) {
                      isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
                      // activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
                      isPrevStepCompleted ? isPrevStepCompleted = true : '';
                    } else {
                      isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
                      activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
                      keyLearnStep && keyLearnStep.length > 0 ? '' : keyLearnStep = stepData[a].stepsList[b].step_id;
                      isPrevStepCompleted = false;
                    }
                  } else {
                    isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
                    // activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
                    isPrevStepCompleted ? isPrevStepCompleted = true : '';
                  }
                } else {
                  isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
                  activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
                  isPrevStepCompleted = false;
                }
              } else {
                isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
                activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
                isPrevStepCompleted = false;
              }
            } else {
              isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
              activeStep && activeStep.length > 0 ? '' : activeStep = stepData[a].stepsList[b].step_id;
              isPrevStepCompleted = false;
            }
          } else {
            isPrevStepCompleted ? visibleStep.push(stepData[a].stepsList[b].step_id) : disabledStep.push(stepData[a].stepsList[b].step_id);
            if (stepData[a].stepsList[b].type == 'Game') {
              if (playedStepsData && playedStepsData.length > 0) {
                let ind = playedStepsData.findIndex(ob => ob.step_id == stepData[a].stepsList[b].step_id);
                if (ind == -1) {
                  if (activatedSteps && activatedSteps) {
                    let ind1 = activatedSteps.findIndex(ob => ob == stepData[a].stepsList[b].step_id);
                    ind1 == -1 ? activateGameStep.push(stepData[a].stepsList[b].step_id) : '';
                  } else {
                    activateGameStep.push(stepData[a].stepsList[b].step_id);
                  }
                }
              } else {
                if (activatedSteps && activatedSteps.length > 0) {
                  let ind1 = activatedSteps.findIndex(ob => ob == stepData[a].stepsList[b].step_id);
                  ind1 == -1 ? activateGameStep.push(stepData[a].stepsList[b].step_id) : '';
                } else {
                  activateGameStep.push(stepData[a].stepsList[b].step_id);
                }
              }
            }
          }
        }
      }
    }

    let obj = {
      visibleStep: visibleStep,
      disabledStep: disabledStep,
      activeStep: activeStep,
      activateGameStep: activateGameStep,
      keyLearnStep: keyLearnStep
    };
    return obj;
  }

  generateTendencyReport(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/tendencyReport', data)
      .map((res: any) => res)
  }

  generateCommTendencyReport(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/commTendencyReport', data)
      .map((res: any) => res)
  }

  saveUserConfig(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/saveUserConfig', data)
      .map((res: any) => res)
  }
  getJourneySubscriptionDate(data) {
    return this.http.post(Configuration.ServerWithApiUrl + '/getJourneySubscriptionDate', data)
      .map((res: any) => res)
  }

  getBatchByUserId(userId) {
    return this.http.get(Configuration.ServerWithApiUrl + '/getBatchByUserId/' + userId)
      .map((res: any) => res)
  }

  getGameTransactionData(gameId: any, userId: any, community_id: any, journey_id: any) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `${this.jwtToken}`
    });
    return this.http.get(Configuration.ServerWithApiUrl + '/transactionMetaData/users/' + userId + '/games/' + gameId + '?community_id=' + community_id + '&journey_id=' + journey_id).map((res: any) => res)
  }

}



// WEBPACK FOOTER //
// ./src/app/Services/journey.service.ts